export default [
{
    letter: "A",
    slug: "the-ascender",
    name: "The Ascender",
    pour: "like you could climb uppercases",
    contre: "could also fall from high",
    vibration: "pretty arrogant about it.",
    direction: "step up a lot but also lose a lot.",
    synthese: "on your way to the top but don’t forget those on the x-height.",
    image: "basteleurcards-01-the-ascender.svg"
},

{
  letter: "B",
    slug: "the-bold",
    name: "The Bold",
    pour: "strong enough to emphasize any message",
    contre: "could also be so noisy that no one will listen to you anymore",
    vibration: "pretty solid about it.",
    direction: "participate in a street fight.",
    synthese: "someone that everybody notices but don’t get too confident.",
    image: "basteleurcards-02-the-bold.svg"
},

{
  letter: "C",
    slug: "the-cedilla",
    name: "The Cedilla",
    pour: "fundamental for whole languages",
    contre: "also are meaningless to others",
    vibration: "hanging around like nothing happened.",
    direction: "overlap with others.",
    synthese: "between two states, meaningful and useless at the same time.",
    image: "basteleurcards-03-the-cedilla.svg"
},

{
  letter: "D",
    slug: "the-descender",
    name: "The Descender",
    pour: "like you could support the ones above you",
    contre: "can sometimes bring things down",
    vibration: "underestimated.",
    direction: "look up to your baseline.",
    synthese: "underneath the others, but when you think about it, you are above the next line.",
    image: "basteleurcards-04-the-descender.svg"
},

{
  letter: "E",
    slug: "the-emdash",
    name: "The Emdash",
    pour: "like you could be the link between two entities",
    contre: "could be used for a bad purpose",
    vibration: "in connection with the ones next to you.",
    direction: "build deeper bonds with someone or something.",
    synthese: "needed for specific things but don’t let others use you for something else.",
    image: "basteleurcards-05-the-emdash.svg"
},

{
  letter: "F",
    slug: "the-font",
    name: "The Font",
    pour: "like a beautiful collection of feelings",
    contre: "could look like a collection of things without coherence",
    vibration: "whole.",
    direction: "feel complete and ready to be useful to the world.",
    synthese: "on your way to a beautiful collection of adventures.",
    image: "basteleurcards-06-the-font.svg"
},

{
  letter: "G",
    slug: "the-glyph",
    name: "The Glyph",
    pour: "like an important part of something bigger",
    contre: "can look insignificant sometimes",
    vibration: "surrounded by your peers.",
    direction: "a path of loneliness if you don’t cooperate with others.",
    synthese: "a small thing but without you there would be nothing.",
    image: "basteleurcards-07-the-glyph.svg"
},

{
  letter: "H",
    slug: "the-hinting",
    name: "The Hinting",
    pour: "very important in some specific cases",
    contre: "know that you could become obsolete at any time",
    vibration: "aware that your future could be compromised.",
    direction: "disappear but you had your moment of glory.",
    synthese: "in a period of change that could be fatal to you if you don’t adapt.",
    image: "basteleurcards-08-the-hinting.svg"
},

{
  letter: "I",
    slug: "the-italic",
    name: "The Italic",
    pour: "like you could change the meaning of things",
    contre: "often lean on somebody else",
    vibration: "different than the upright people.",
    direction: "fall forward if you push yourself too much.",
    synthese: "different than the others and that’s what put the spotlight on you.",
    image: "basteleurcards-09-the-italic.svg"
},

{
  letter: "J",
    slug: "justify",
    name: "Justify",
    pour: "very square and solid",
    contre: "could break at any moment if you’re not set properly",
    vibration: "monolithic.",
    direction: "a very straight and upright future if you don’t let loose.",
    synthese: "strong but don’t forget that a very small change inside you could break everything.",
    image: "basteleurcards-10-justify.svg"
},

{
  letter: "K",
    slug: "the-kerning",
    name: "The Kerning",
    pour: "like you could get closer to your neighbour",
    contre: "think that it will take a lot of time",
    vibration: "patient about it.",
    direction: "get closer with the person at your right or left.",
    synthese: "good at making connection but it takes a lot of time.",
    image: "basteleurcards-11-the-kerning.svg"
},

{
  letter: "L",
    slug: "the-lowercase",
    name: "The Lowercase",
    pour: "very useful in a lot of situations",
    contre: "feel often smaller than others",
    vibration: "lower than ever.",
    direction: "underestimate yourself.",
    synthese: "smaller than others but you are more than needed.",
    image: "basteleurcards-12-the-lowercase.svg"
},

{
  letter: "M",
    slug: "the-masters",
    name: "The Masters",
    pour: "like the essential part of the whole system",
    contre: "have a lot of responsibility",
    vibration: "the backbone of something bigger.",
    direction: "overestimate yourself.",
    synthese: "the essential part of something bigger but that brings a lot of responsibilities.",
    image: "basteleurcards-13-the-masters.svg"
},

{
  letter: "N",
    slug: "the-newfont",
    name: "The NewFont",
    pour: "fresh and ready for a new adventure",
    contre: "have accomplished nothing yet",
    vibration: "pretty fresh about it.",
    direction: "something either wonderful or ugly.",
    synthese: "in your way to a whole new adventure.",
    image: "basteleurcards-14-the-newfont.svg"
},

{
  letter: "O",
    slug: "the-opentype",
    name: "The Opentype",
    pour: "like you can bring some magic to the world",
    contre: "are very restrictive",
    vibration: "useful to a lot of people.",
    direction: "create some very interesting stuff.",
    synthese: "very important but very narrow minded.",
    image: "basteleurcards-15-the-opentype.svg"
},

{
  letter: "P",
    slug: "the-point",
    name: "The Point",
    pour: "like you are the structure of everything",
    contre: "are always on the extreme",
    vibration: "pretty extreme about it.",
    direction: "overestimate yourself but never forget that you are only a small part of something bigger.",
    synthese: "vital for a lot of stuff but don’t get cocky.",
    image: "basteleurcards-16-the-point.svg"
},

{
  letter: "Q",
    slug: "the-quotemark",
    name: "The Quotemark",
    pour: "like you can make people talk",
    contre: "never really speak for yourself",
    vibration: "“happy” about it.",
    direction: "help other people to talk.",
    synthese: "a good messenger.",
    image: "basteleurcards-17-the-quotemark.svg"
},

{
  letter: "R",
    slug: "the-revival",
    name: "The Revival",
    pour: "like you are between tradition and modernity",
    contre: "are sometime just a lazy copy of someone else",
    vibration: "always looking back to the past.",
    direction: "copy the elders without thinking.",
    synthese: "coming back from the future.",
    image: "basteleurcards-18-the-revival.svg"
},

{
  letter: "S",
    slug: "the-sans",
    name: "The Sans",
    pour: "neutral",
    contre: "can look boring sometimes",
    vibration: "feeling neutral about it.",
    direction: "be the default choice for a mission.",
    synthese: "bland but in the right hands you can look amazing.",
    image: "basteleurcards-19-the-sans.svg"
},

{
  letter: "T",
    slug: "the-type-designer",
    name: "The Type Designer",
    pour: "useless to society",
    contre: "can argue over small stupid details",
    vibration: "friend with a lot of designers.",
    direction: "focus too much on small details.",
    synthese: "very focus on the details but don’t forget the bigger picture.",
    image: "basteleurcards-20-the-type-designer.svg"
},

{
  letter: "U",
    slug: "the-uppercase",
    name: "The Uppercase",
    pour: "strong and stable",
    contre: "look like you are SCREAMING all the time",
    vibration: "above most of people.",
    direction: "speak too loud.",
    synthese: "patronizing, get off your high horse.",
    image: "basteleurcards-21-the-uppercase.svg"
},

{
  letter: "VWXYZ",
    slug: "the-other-ones",
    name: "The Other ones",
    pour: "less important than the others",
    contre: "don’t know what you’re supposed to be",
    vibration: "clueless about it.",
    direction: "be the at end of everything.",
    synthese: "annoying for most of the type designers.",
    image: "basteleurcards-22-the-other-ones.svg"
}] 